import React from "react";

const SendMessageIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 10.8333V5C18.3333 4.55798 18.1577 4.13405 17.8451 3.82149C17.5326 3.50893 17.1087 3.33334 16.6666 3.33334H3.33329C2.89127 3.33334 2.46734 3.50893 2.15478 3.82149C1.84222 4.13405 1.66663 4.55798 1.66663 5V15C1.66663 15.9167 2.41663 16.6667 3.33329 16.6667H9.99996M18.3333 5.83334L10.8583 10.5833C10.601 10.7445 10.3036 10.83 9.99996 10.83C9.69636 10.83 9.3989 10.7445 9.14163 10.5833L1.66663 5.83334M15.8333 13.3333V18.3333M13.3333 15.8333H18.3333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendMessageIcon;
